import React, { useEffect, useState } from 'react'
import { motion, AnimatePresence } from "framer-motion";
import { cast_wishlist_vote, get_marketplace_wishlist } from '../../api/auth';

const VoteItem = ({title, totalVotes, isSelected, onClick}) => {
  return (
    <motion.div
      className={`p-4 md:p-[20px] my-4 bg-light-purple-100 border-new-grey-100 rounded-xl `}
      initial={false}
      animate={{ backgroundColor: isSelected ? "#F0ECFC" : "#F8F8F7" }}
      onClick={onClick}
    >
      <div className={`flex justify-between items-center`}>
        <p className="font-semibold text-sm font-inter lg:text-xl">
          {title}
        </p>
        <div className="p-2 md:p-4 border rounded-full border-light-purple-300 justify-between items-center">
          {
            isSelected && (
              <p className='font-semibold text-xs font-inter text-center'>
                {parseInt(totalVotes) + 1} votes
              </p>
            )          
          }
        </div>
      </div>
    </motion.div>
  )
}



const DefaultOptions = [
  {
    title: "Fresh Vegetables (Ugu, Waterleaves, Okro)",
    totalVotes: 2567,
    id:1234
  },
  {
    title: "Cleaning Supplies (Detergent, Disinfectant, Bleach)",
    totalVotes: 4688,
    id:12345
  },
  {
    title: "Food Staples (Tomatoes, Potatoes, Crayfish, Rice)",
    totalVotes: 9788,
    id:12346
  },
  {
    title: "Proteins (Frozen Foods, Beef Sharing, Fish, Seafood)",
    totalVotes: 11234,
    id:12347
  },
  {
    title: "Cooking Essentials (Palm Oil, Vegetable Oil, Seasonings)",
    totalVotes: 9788,
    id:12348
  },
  {
    title: "Snacks & Beverages (Biscuits, Drinks, Cereals)",
    totalVotes: 9788,
    id:12349
  },
  {
    title: "Personal Care Items (Toiletries, Sanitary Products)",
    totalVotes: 9788,
    id:12343
  },
  {
    title: "Baby & Kids Essentials (Diapers, Baby Food, Wipes)",
    totalVotes: 109788,
    id:1232
  },
]

export default function NewProductVote() {
  const [selectedIndices, setSelectedIndices] = useState([]);
  const [wishlist, setWishList] = useState([])

  useEffect(() => {
    fetchOptions()
  }, [])

  const handleItemClick = async(num, id) => {
    if (!selectedIndices.includes(num)) {
      setSelectedIndices([...selectedIndices, num]);
      cast_wishlist_vote(id)
    } else {
      setSelectedIndices(selectedIndices.filter((n) => n !== num));
    }
  };

  const fetchOptions = async () => {
    try {
      const res = await get_marketplace_wishlist()
      const response = await res.json()
      console.log('response', response);
      

      if (res.ok && response.data?.length) {        
        setWishList(response.data)
      } else {
        setWishList([])
      }
    } catch (error) {
      setWishList([])
    }
  }

  if (!wishlist.length) {
    return (<></>)
  }
  
  return (
    <section className=" w-ful">
      <div className="container mx-auto px-4 py-24">
        <p
          className="font-sora text-center text-[30px] leading-[39px] font-semibold my-4 xl:my-5 xl:text-5xl xl:leading-[60px] "
          style={{ textWrap: "balance" }}
        >
          What Would You Like to See in the Marketplace?
        </p>
        <p
          className="font-sora text-center text-[16px] leading-[39px] font-semibold xl:text-2xl mb-8"
          style={{ textWrap: "balance" }}
        >
          Select all that apply
        </p>

        {
          wishlist.map((item, index) => {
            return (
              <VoteItem
                key={index}
                title={item.title}
                totalVotes={item.total_votes}
                isSelected={selectedIndices.includes(index)}
                onClick={() => handleItemClick(index, item.id)}
              />
            )
          })
        }
      </div>
    </section>
  )
}
